import { render, staticRenderFns } from "./asset-autocomplete.vue?vue&type=template&id=4d98b6d4&scoped=true&"
import script from "./asset-autocomplete.vue?vue&type=script&lang=js&"
export * from "./asset-autocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d98b6d4",
  null
  
)

export default component.exports